import axios from 'axios'
import config from '@/config';
import {
    log
} from '@/logging';

export default {
    async createContact(number, rut) {
        log.info("interaciont mark, here im gonna send this params", number, rut);
        const params = {
            opcion: number,
            rut: rut
        };
        const response = await axios.post(config.endpoints.contact, params);
        if (response.data.data === "true" && response.data.data !== undefined) {
            log.info("agregarContacto true!");
            return response.data.data;
        } else {
            // log.error("Error trying to generate contact (\"interacciones\"");
        }
    },
    async insertInteraction(idInteraccionCanal, rut, observacion) {
        const params = {
            idInteraccionCanal: idInteraccionCanal,
            rut: rut,
            observacion: observacion ? observacion : null
        };

        try {
            const response = await axios.post(config.endpoints.registrarIntereaccion, params);
            console.log("response nueva interaccion", response)

        } catch (error) {

            console.log('Error al registrar interaccion Modal HBO:', error);
        }
    }
}